import React from 'react';

export const TeamsIconBorderless = (): React.JSX.Element => (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M9.7652 4.97366H13.3814C13.7231 4.97366 14 5.25572 14 5.60366V8.95822C14 10.237 12.9821 11.2736 11.7265 11.2736H11.7157C10.4601 11.2738 9.44208 10.2373 9.44189 8.95855C9.44189 8.95844 9.44189 8.95833 9.44189 8.95821V5.30292C9.4419 5.12108 9.58665 4.97366 9.7652 4.97366Z"
			fill="#5059C9"
		/>
		<path
			d="M12.2091 4.31048C13.0183 4.31048 13.6742 3.64245 13.6742 2.81839C13.6742 1.99433 13.0183 1.32629 12.2091 1.32629C11.4 1.32629 10.744 1.99433 10.744 2.81839C10.744 3.64245 11.4 4.31048 12.2091 4.31048Z"
			fill="#5059C9"
		/>
		<path
			d="M7.65112 4.3105C8.8199 4.3105 9.76739 3.34556 9.76739 2.15525C9.76739 0.964938 8.8199 0 7.65112 0C6.48234 0 5.53485 0.964938 5.53485 2.15525C5.53485 3.34556 6.48234 4.3105 7.65112 4.3105Z"
			fill="#7B83EB"
		/>
		<path
			d="M10.473 4.97366H4.5038C4.16623 4.98217 3.89919 5.26748 3.90702 5.61129V9.43735C3.85988 11.5005 5.46262 13.2126 7.48839 13.2631C9.51417 13.2126 11.1169 11.5005 11.0698 9.43735V5.61129C11.0776 5.26748 10.8106 4.98217 10.473 4.97366Z"
			fill="#7B83EB"
		/>
		<path
			opacity="0.1"
			d="M7.81386 4.97366V10.3353C7.81224 10.5811 7.66594 10.802 7.4427 10.8956C7.37162 10.9262 7.29523 10.942 7.21805 10.942H4.19342C4.1511 10.8326 4.11203 10.7232 4.07947 10.6105C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.81386Z"
			fill="black"
		/>
		<path
			opacity="0.2"
			d="M7.48829 4.97366V10.6668C7.48827 10.7454 7.47277 10.8232 7.4427 10.8956C7.35078 11.123 7.1339 11.272 6.89248 11.2736H4.34644C4.29109 11.1642 4.239 11.0548 4.19342 10.942C4.14784 10.8293 4.11203 10.7232 4.07947 10.6105C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.48829Z"
			fill="black"
		/>
		<path
			opacity="0.2"
			d="M7.48828 4.97366V10.0037C7.4858 10.3378 7.2205 10.6079 6.89247 10.6105H4.07947C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.48828Z"
			fill="black"
		/>
		<path
			opacity="0.2"
			d="M7.1627 4.97366V10.0037C7.16021 10.3378 6.89491 10.6079 6.56689 10.6105H4.07947C3.9655 10.23 3.90735 9.83447 3.90691 9.43669V5.61029C3.89908 5.26704 4.16568 4.98217 4.50272 4.97366H7.1627Z"
			fill="black"
		/>
		<path
			opacity="0.1"
			d="M7.81402 3.25928V4.30374C7.75867 4.30706 7.70658 4.31038 7.65123 4.31038C7.59588 4.31038 7.54379 4.30706 7.48844 4.30374C7.37854 4.29631 7.26955 4.27856 7.16286 4.25069C6.50356 4.09168 5.95887 3.62079 5.69775 2.98407C5.65282 2.87715 5.61794 2.76612 5.59357 2.6525H7.21821C7.54675 2.65376 7.81277 2.92468 7.81402 3.25928Z"
			fill="black"
		/>
		<path
			opacity="0.2"
			d="M7.48819 3.59097V4.30386C7.3783 4.29644 7.2693 4.27868 7.16262 4.25081C6.50331 4.0918 5.95863 3.62091 5.69751 2.98419H6.89238C7.22092 2.98546 7.48694 3.25638 7.48819 3.59097Z"
			fill="black"
		/>
		<path
			opacity="0.2"
			d="M7.48819 3.59097V4.30386C7.3783 4.29644 7.2693 4.27868 7.16262 4.25081C6.50331 4.0918 5.95863 3.62091 5.69751 2.98419H6.89238C7.22092 2.98546 7.48694 3.25638 7.48819 3.59097Z"
			fill="black"
		/>
		<path
			opacity="0.2"
			d="M7.16262 3.59098V4.25081C6.50332 4.0918 5.95863 3.62091 5.69751 2.98419H6.56681C6.89535 2.98546 7.16137 3.25639 7.16262 3.59098Z"
			fill="black"
		/>
		<path
			d="M0.596783 2.98419H6.56595C6.89555 2.98419 7.16273 3.25631 7.16273 3.59197V9.67109C7.16273 10.0068 6.89554 10.2789 6.56595 10.2789H0.596783C0.267186 10.2789 0 10.0068 0 9.67109V3.59197C0 3.25631 0.267193 2.98419 0.596783 2.98419Z"
			fill="url(#paint0_linear_2230_19259)"
		/>
		<path
			d="M5.15193 5.29794H3.95868V8.60707H3.19846V5.29794H2.01074V4.65601H5.15193V5.29794Z"
			fill="white"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_2230_19259"
				x1="1.24431"
				y1="2.50928"
				x2="6.04757"
				y2="10.6779"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5A62C3" />
				<stop offset="0.5" stopColor="#4D55BD" />
				<stop offset="1" stopColor="#3940AB" />
			</linearGradient>
		</defs>
	</svg>
);
